import BaseService from '@/services/Service';

export default new class AbandonedCartService {
	/**
	 * Saves (creates or updates) the abandoned-cart row for the current cart.
	 * `location` is sent as a sibling of `data` (not nested inside it) so
	 * `ReservationsController::__security()` can resolve the WP location the
	 * same way `saveReservation` does.
	 */
	public save(data: any, location: string): Promise<any> {
		return BaseService.post('saveAbandonedCart', { data, location });
	}

	/**
	 * Best-effort save via `navigator.sendBeacon` so the request survives the
	 * tab/page being closed - used when the customer is navigating away
	 * mid-flow, which is exactly when a normal axios request could get
	 * cancelled before it lands.
	 */
	public saveBeacon(data: any, location: string): void {
		if (!navigator.sendBeacon) {
			this.save(data, location).catch(() => {});
			return;
		}

		const blob = new Blob(
			[JSON.stringify({ method: 'saveAbandonedCart', data, location })],
			{ type: 'application/json' },
		);

		navigator.sendBeacon(BaseService.ajaxUrl, blob);
	}
}();
